export default __webpack_public_path__ + "static/media/10.9855edb1.png";